import ResourceModel from "models/convention-api/ResourceModel"

export default class ConventionProviderExhibitorCount extends ResourceModel {
  protected static basePath =
    "/v1/convention_providers/:provider_id/convention_provider_exhibitor_counts"

  count!: number
}
